import { translate } from './i18n';
import { RfiStatus } from '../sdk/types';
import { RfiFilterStatus } from '../sdk';
import { OneOrArray } from '../types';
import { getStatusColorMapping } from '../constants';

export const OPEN_STATUSES: RfiStatus[] = [RfiStatus.Open, RfiStatus.OpenRev1, RfiStatus.OpenRev2];
export const isOneOfOpenStatuses = (status?: RfiStatus): boolean =>
  status ? OPEN_STATUSES.includes(status) : false;

export const ANSWERED_STATUSES: RfiStatus[] = [
  RfiStatus.Answered,
  RfiStatus.AnsweredManager,
  RfiStatus.AnsweredRev1,
];

export const isOneOfAnsweredStatuses = (status?: RfiStatus): boolean =>
  status ? ANSWERED_STATUSES.includes(status) : false;

export const getSubStatusFromServerStatus = (
  serverStatus?: RfiStatus,
  prevStatus: RfiStatus | null = null,
) => {
  switch (serverStatus) {
    case RfiStatus.Open:
    case RfiStatus.OpenRev1:
    case RfiStatus.OpenRev2:
    case RfiStatus.Submitted:
    case RfiStatus.Answered:
    case RfiStatus.AnsweredRev1:
    case RfiStatus.AnsweredManager:
      return serverStatus;
    case RfiStatus.Draft:
      return prevStatus === RfiStatus.Submitted ? 'draftReturned' : null;
    default:
      return null;
  }
};

export const getStatusLabel = (
  serverStatus: RfiStatus,
  isCreateMode = false,
  prevStatus: RfiStatus | null = null,
): { statusLabel: string; subStatusLabel: string | null } => {
  const subStatus = getSubStatusFromServerStatus(serverStatus, prevStatus);
  const subStatusLocalizationKey = isCreateMode ? 'subStatus.createMode.' : 'subStatus.';
  const subStatusLabel = subStatus ? translate(subStatusLocalizationKey + subStatus) : null;
  const translationPrefix = isCreateMode ? 'statusInCreateForm' : 'status';

  return {
    statusLabel: translate(`${translationPrefix}.${serverStatus}`),
    subStatusLabel,
  };
};

export const getStatusColor = (serverStatus: RfiStatus): string =>
  getStatusColorMapping(serverStatus);

export const mapRequestStatusFiltersToServerFilters = (
  filterStatus: OneOrArray<RfiFilterStatus> | undefined,
): RfiStatus[] | undefined => {
  if (!filterStatus) {
    return filterStatus;
  }

  const statuses = Array.isArray(filterStatus) ? filterStatus : [filterStatus];
  if (statuses.includes(RfiFilterStatus.All)) {
    return Object.values(RfiStatus);
  }

  // If "RfiFilterStatus.All" doesn't exist in "statuses" it has the same values as in "RfiStatus" enum
  const statusesAsRfiStatuses = statuses as unknown as RfiStatus[];
  return statusesAsRfiStatuses.reduce((acc, status) => {
    switch (status) {
      case RfiStatus.Answered:
        return [...acc, ...ANSWERED_STATUSES];
      case RfiStatus.Open:
        return [...acc, ...OPEN_STATUSES];
      default:
        return [...acc, status];
    }
  }, [] as RfiStatus[]);
};

export const RFIS_SORTED_STATUSES: RfiStatus[] = [
  RfiStatus.Draft,
  RfiStatus.Submitted,
  RfiStatus.Open,
  RfiStatus.Answered,
  RfiStatus.Closed,
  RfiStatus.Void,
];

export const RFIS_INNER_STATUSES: RfiStatus[] = [
  RfiStatus.OpenRev1,
  RfiStatus.OpenRev2,
  ...RFIS_SORTED_STATUSES,
];
